import { AlertColor } from '@mui/material';

import { AlertVariants } from './types';

export const alertVariantToMuiSeverity: Record<AlertVariants, AlertColor> = {
  danger: 'error',
  default: 'info',
  main: 'success',
  warning: 'warning',
};
